module.exports = __webpack_public_path__ + "media/images/flags/64/Wallis-And-Futuna-47779dc69196608528d920aa21cc75d3.png";